import { Map as ImmutableMap, Record } from 'immutable';
import type { QcsSyncResourceStore, QcsSyncResourceStoreProps } from '../core/resourceStoreTypes';

export const HOUSINGSELECTION_REDUCER_KEY = 'zillowHousingSelectionStore';

export type HousingSelectionStore = QcsSyncResourceStore<HousingSelectionType>;

type AssetDetailsList = {
  thirdPartyName: string;
  thirdPartyPropertyID: string;
  value: number;
  useCode: string;
  bedrooms: string;
  bathrooms?: string;
  propertySqFt: number;
  areaSquareFeet: string;
  noOfUnits: number;
  totalRooms: number;
  totalStories: number;
  yearBuilt: number;
  numberOfBuildings: number;
  ownerName: string;
  zestimateTime: string;
  rentalZestimate: number;
  rentalTimestamp: string;
  detailsURL: string;
};

export type HousingSelectionType = {
  id?: string;
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  assetDetailsList?: Array<AssetDetailsList>;
  isDeleted?: false;
  full?: string;
  bedrooms?: string;
  bathrooms?: string;
  areaSquareFeet?: string;
};

export const mkHousing = Record<HousingSelectionType>({
  id: undefined,
  line1: undefined,
  city: undefined,
  state: undefined,
  zipCode: undefined,
  assetDetailsList: undefined,
  isDeleted: false,
  line2: undefined,
  bedrooms: undefined,
  bathrooms: undefined,
  full: undefined,
  areaSquareFeet: undefined,
});

export const mkHouseSelectionStore = Record<QcsSyncResourceStoreProps<HousingSelectionType>>({
  resourcesById: ImmutableMap(),
  loadPending: true,
  isLoading: false,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [HOUSINGSELECTION_REDUCER_KEY]: HousingSelectionStore;
  }
}
